import { useLocation } from 'react-router-dom';
import { whatsappLink } from '../../lib/whatsapp';

// Rotas internas (área logada / admin) onde o botão flutuante não deve aparecer,
// para não poluir dashboards, player de aula e checkout.
const HIDDEN_PREFIXES = [
  '/dashboard',
  '/admin',
  '/instructor',
  '/aula',
  '/meu-perfil',
  '/checkout',
];

export default function FloatingWhatsAppButton() {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      title="Falar no WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/30 hover:scale-110 active:scale-95 transition-transform duration-200"
    >
      <i className="ri-whatsapp-line text-3xl" aria-hidden="true"></i>
    </a>
  );
}
